<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_25",
      next: "P_27",
      topic: "Estás en: Taller ¿Qué es crédito? / ¿En qué consiste?",
      dialog: false,
      respuesta: null,
      sent: false,
      hideAll: false,
      resultado: 0,
      correcta: 2,
      fontSize: 24,
    };
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("send_suspend_data", this.respuesta);
    }
  },
  created() {
    if ("suspend_data" in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    }
  }
};
</script>

<style lang="stylus">
.btn-reactivo, .btn-reactivo:hover {
  height: 100%;
  width: 100%;
  color: #D4EDFC !important;
  border: 3px;
  border-color: #49A5E6 !important;
}

.reactivo-container {
  position: absolute;
}

.correctClass {
  border-color: #48AE64;
  background-color: rgba(136, 202, 154, 0.2);
}

.incorrectClass {
  border-color: #D0021B;
  background-color: rgba(218, 56, 81, 0.2);
}

.tooltip {
  // ...
  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: white;
      position: absolute;
      color: black;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
  }
}
</style> 


<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, align-center justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 8 DE 9
            v-card-text.titulo24Reg
              | ¿En qué crédito se utiliza tu salario como referencia para determinar el monto? 
            v-card-text.parrafoDestacadoB.text-center
              | Selecciona una opción
            v-icon.pt-3.pr-3(color="accent") fas fa-bolt
            span.parrafoDestacado.accent--text
              b Información para decidir:
              |  Ten presente que esta información detalla las características más relevantes de cada tipo de crédito. 
            
            v-container(grid-list-xs) 
              v-layout(row wrap)
                v-flex.xs12.md4
                  v-card.button_select.v-card.balance_inactive.mt-0.pt-4(dark flat min-height=70 )
                    b.title.pt-2 Hipotecario
                    v-icon.pa-2.toolTip.check(small color="white") fas fa-check
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Te permite adquirir un patrimonio como casa, terreno o departamento. 
                        li.b.red--text Puedes compartir el crédito con tu pareja. 
                        li.b Las propiedades pueden aumentar su valor. 
                        li.b La propiedad actúa como garantía del crédito. 
                        li.b Las tasas de interés hipotecarias son relativamente bajas y puedes acceder a varios esquemas: tasa de interés fija, tasa de interés variable y tasa de interés máxima.
                        li.b Una parte del interés que se paga es deducible de impuestos. 
                        li.b Facilidades para tramitarlo. 
                v-flex.xs12.md4 
                  v-card.button_select.v-card.green.mt-0.pt-4(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==1) }" @click="respuesta=1")
                    b.title.pt-2 Automotriz
                    v-icon.pa-2.toolTip.check(v-if="!sent && (respuesta==1)" small color="white") fas fa-circle
                    v-icon.pa-2.toolTip.check(small color="white" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Te permite adquirir un auto sin tener que pagar el costo total en ese momento. 
                        li.b El desembolso inicial es menor; el enganche de un automóvil puede ser alrededor del 20% del valor del automóvil. 
                        li.b Puedes ajustar las variables del crédito según el tipo de vehículo que te gustaría, dependiendo de tu nivel de ingresos o del valor del auto: Puedes elegir distintos plazos, y puedes pedir una mayor línea de crédito. 
                        li.b El crédito se liquida poco a poco mediante pagos mensuales. 
                        li.b El seguro generalmente se incluye en la mensualidad. 
                v-flex.xs12.md4  
                  v-card.button_select.v-card.green.mt-0.pt-4(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==2) }" @click="respuesta=2")
                    b.title.pt-2 Nómina
                    v-icon.pa-2.toolTip.check(v-if="!sent && (respuesta==2)" small color="white") fas fa-circle
                    v-icon.pa-2.toolTip.check(small color="white" v-else) far fa-circle
                    v-icon.pa-2.toolTip.check(v-if="sent && (respuesta==2)" small color="white") fas fa-check
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b.red--text(v-if="sent && (respuesta==2)")  Para determinar el monto se utiliza tu salario como referencia.                       
                        li.b Puedes usarlo para adquirir múltiples bienes y/o servicios. 
                        li.b Es útil para enfrentar emergencias e imprevistos. 
                        li.b La mayoría de los bancos otorgan el préstamo de forma inmediata sin necesidad de garantía o aval ya que te respalda la estabilidad del depósito de tu nómina. 
                        li.b Las tasas de interés son más atractivas comparadas con otros créditos. 
                        li.b Es útil para iniciar tu reporte de crédito. 
              v-layout(row wrap align-center justify-center)
                v-flex.xs12.md4  
                  v-card.button_select.v-card.green.mt-0.pt-4(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==3) }" @click="respuesta=3")
                    b.title.pt-2 PYME
                    v-icon.pa-2.toolTip.check(v-if="!sent && (respuesta==3)" small color="white") fas fa-circle
                    v-icon.pa-2.toolTip.check(small color="white" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Puedes financiar el capital de trabajo de tu negocio a mediano plazo. 
                        li.b Te permite adquirir activos fijos o equipamiento para tu negocio. 
                        li.b Puedes asegurar que tu negocio tenga flujo suficiente a corto plazo. 
                        li.b La tasa de interés es relativamente baja.  
                v-flex.xs12.md4  
                  v-card.button_select.v-card.green.mt-0.pt-4(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==4) }" @click="respuesta=4")
                    b.title.pt-2 Tarjeta de Crédito
                    v-icon.pa-2.toolTip.check(v-if="!sent && (respuesta==4)" small color="white") fas fa-circle
                    v-icon.pa-2.toolTip.check(small color="white" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Puedes usarla para adquirir múltiples bienes y/o servicios. 
                        li.b Es útil para enfrentar emergencias e imprevistos. 
                        li.b El trámite es rápido y sencillo. 
                        li.b Es útil para iniciar tu reporte de crédito. 
                v-flex.xs12.md4  
                  v-card.button_select.v-card.green.mt-0.pt-4(dark flat min-height=70 v-bind:class="{ balance_inactive: (respuesta==5) }" @click="respuesta=5")
                    b.title.pt-2 Crédito al consumo
                    v-icon.pa-2.toolTip.check(v-if="!sent && (respuesta==5)" small color="white") fas fa-circle
                    v-icon.pa-2.toolTip.check(small color="white" v-else) far fa-circle
                  v-container.grey.lighten-4.px-2
                    v-card.grey.lighten-4.text-xs-left(style="overflow-y: scroll; height:140px;" flat min-height=140)
                      .bt Características:
                      ul.b
                        li.b Es solicitado por un consumidor para financiar la adquisición de bienes y servicios para uso no profesional. 
                        li.b Se puede solicitar en los propios establecimientos vendedores de bienes y servicios. 
                        li.b La tasa de interés puede ser más elevada que con otros tipos de crédito. 
                        li.b La variedad de cosas que puede adquirir con este tipo de financiamiento es muy amplia. 
            
            v-layout(row, justify-center)
              v-flex
                v-btn.btn(v-if="!sent" color='accent' v-bind:class='responseIsNone' :disabled="respuesta==null" style='z-index:2', @click.prevent='sent=true; dialog=true')
                  | Revisar                           
                v-btn.btn.dialog_btn(v-else color='accent' style="z-index:2; !important" @click.prevent="nextPage(next)")
                  | Siguiente
                v-dialog(v-model='dialog ', persistent, max-width='930px ')
                  v-layout(row, justify-center)
                    v-flex(text-xs-center)
                      v-card.pb-4
                        div(v-if='sent && (respuesta==correcta) ')
                          v-layout(v-if='dialog ')
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoOk.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline.py-5
                            | ¡Muy Bien!
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="dialog=false;")
                            | Continuar
                        div(v-if='sent && (respuesta!=correcta) ')
                          v-layout(v-if='dialog ')
                            v-flex(text-xs-center)
                              img.dialog_img(src='@/assets/ManoStop.png')
                          v-spacer.my-1.py-4
                          v-card-text.headline.py-5
                            | Inténtalo de nuevo
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="dialog=false; respuesta=null; sent=false;")
                            | Continuar
          l-progress(:value='this.$parent.currentPage')
</template>

<style scoped lang="stylus">


.b 
.bt
  color #6E6E6E
  font-weight normal
  font-size 12px
  line-height 2em

.bt
  font-weight bold
  padding-left 24px

.button_select
  width 100% !important
  height 70px !important
  margin 0
  padding 0
  box-shadow none
  border-radius 0

.check
  position absolute 
  top -24px
  right 0px

::-webkit-scrollbar
  -webkit-appearance none
  width: 7px

::-webkit-scrollbar-thumb 
  border-radius 4px
  background-color rgba(0,0,0,.5)
  -webkit-box-shadow 0 0 1px rgba(255,255,255,.5)


</style>


